import "core-js/modules/es.array.push.js";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { path as getSelfServeRecommendedArticleRoute } from "@faire/web-api/routes/support/self-serve/recommended-article";
import { useHistory } from "react-router-dom";
import { FaireDirectDiscountsDataFn } from "../instantAnswerDataFunctions/faireDirectDiscountsDataFn";
import { ShippingContextDataFn } from "../instantAnswerDataFunctions/shippingContextDataFn";
import { ShouldDisplayMessageCTADataFn } from "../instantAnswerDataFunctions/shouldDisplayMessageCTADataFn";
export var NEED_MORE_INFO = function NEED_MORE_INFO(strictLocalize) {
  return strictLocalize({
    id: "I/a68g",
    defaultMessage: [{
      "type": 0,
      "value": "We hebben mogelijk meer informatie nodig om je probleem op te lossen"
    }]
  });
};
var isBrand = function isBrand() {
  var retailerToken = getRetailerToken();
  if (retailerToken) {
    return false;
  }
  return true;
};
var GENERAL_MESSAGE_RETAILER_OR_BRAND = function GENERAL_MESSAGE_RETAILER_OR_BRAND(strictLocalize) {
  if (isBrand()) {
    return strictLocalize({
      id: "lDcUNv",
      defaultMessage: [{
        "type": 0,
        "value": "Neem voor een snellere oplossing eerst contact op met de klant"
      }]
    });
  }
  return strictLocalize({
    id: "jXjtIm",
    defaultMessage: [{
      "type": 0,
      "value": "Neem voor een snellere oplossing eerst contact op met het merk"
    }]
  });
};
var GENERAL_MESSAGE_RETAILER_OR_BRAND_BUTTON = function GENERAL_MESSAGE_RETAILER_OR_BRAND_BUTTON(history, strictLocalize) {
  if (isBrand()) {
    return {
      label: strictLocalize({
        id: "J31qiB",
        defaultMessage: "Message the retailer"
      }),
      onClick: function onClick() {
        return messageRetailerOrBrandOnClick(history);
      }
    };
  }
  return {
    label: strictLocalize({
      id: "RQw6mA",
      defaultMessage: "Message the brand"
    }),
    onClick: function onClick() {
      return messageRetailerOrBrandOnClick(history);
    }
  };
};
var GENERAL_MESSAGE_DESCRIPTION_RETAILER_OR_BRAND = function GENERAL_MESSAGE_DESCRIPTION_RETAILER_OR_BRAND(strictLocalize) {
  if (isBrand()) {
    return strictLocalize({
      id: "O2+rZ+",
      defaultMessage: [{
        "type": 0,
        "value": "Meestal kan dit soort problemen worden opgelost door contact op te nemen met de klant. Als zij je niet kunnen helpen, kun je altijd terugkomen en contact met ons opnemen."
      }]
    });
  }
  return strictLocalize({
    id: "Pwzacl",
    defaultMessage: [{
      "type": 0,
      "value": "Meestal kan dit soort problemen worden opgelost door contact op te nemen met het merk. Als ze niet kunnen helpen, kun je altijd terugkomen en contact met ons opnemen."
    }]
  });
};
export var SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT = function SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT(strictLocalize, context) {
  if (context.brandOrder) {
    return isBrand() ? strictLocalize({
      id: "O2+rZ+",
      defaultMessage: [{
        "type": 0,
        "value": "Meestal kan dit soort problemen worden opgelost door contact op te nemen met de klant. Als zij je niet kunnen helpen, kun je altijd terugkomen en contact met ons opnemen."
      }]
    }) : strictLocalize({
      id: "Pwzacl",
      defaultMessage: [{
        "type": 0,
        "value": "Meestal kan dit soort problemen worden opgelost door contact op te nemen met het merk. Als ze niet kunnen helpen, kun je altijd terugkomen en contact met ons opnemen."
      }]
    });
  }
  return GENERAL_MESSAGE_DESCRIPTION_RETAILER_OR_BRAND(strictLocalize);
};
export var SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT = function SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT(strictLocalize, context) {
  if (context.brandOrder) {
    var selectedBrandOrder = context.brandOrder;
    var brandName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_name;
    var retailerName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.retailer_name;
    var conversationName = isBrand() ? retailerName : brandName;
    if (!conversationName) {
      return GENERAL_MESSAGE_RETAILER_OR_BRAND(strictLocalize);
    }
    return strictLocalize({
      id: "cFFGWB",
      defaultMessage: [{
        "type": 0,
        "value": "Neem voor een snellere oplossing eerst contact op met "
      }, {
        "type": 1,
        "value": "conversationCompanyName"
      }]
    }, {
      conversationCompanyName: conversationName
    });
  }
  return GENERAL_MESSAGE_RETAILER_OR_BRAND(strictLocalize);
};
export var MessageRetailerOrBrandButton = function MessageRetailerOrBrandButton(context, strictLocalize) {
  var history = useHistory();
  var brandOrder = context.brandOrder;
  if (!brandOrder || !context.shouldDisplayCTAOfContactBrandOrRetailer) {
    return undefined;
  }
  var selectedBrandOrder = context.brandOrder;
  var brandName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_name;
  var retailerName = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.retailer_name;
  var conversationName = isBrand() ? retailerName : brandName;
  if (!conversationName) {
    return GENERAL_MESSAGE_RETAILER_OR_BRAND_BUTTON(history, strictLocalize);
  }
  return {
    label: strictLocalize({
      id: "07TJUq",
      defaultMessage: "Message {conversationCompanyName}"
    }, {
      conversationCompanyName: conversationName
    }),
    onClick: function onClick() {
      return messageRetailerOrBrandOnClick(history);
    }
  };
};
var messageRetailerOrBrandOnClick = function messageRetailerOrBrandOnClick(history) {
  if (history) {
    history.push(getSelfServeRecommendedArticleRoute({
      message_modal: "1"
    }));
  }
};
export var additionalDataRequiredForContactingRetailerOrBrandCTA = function additionalDataRequiredForContactingRetailerOrBrandCTA() {
  return [ShippingContextDataFn, ShouldDisplayMessageCTADataFn];
};
export var additionalDataRequiredForFaireDiscountsSignUpOfferIA = function additionalDataRequiredForFaireDiscountsSignUpOfferIA() {
  return [FaireDirectDiscountsDataFn];
};